var _style, _g, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeAssineSeusDocumentosEletronicamenteAggerPopup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0DocumentosEletronicosPopup{fill:#F7B500;}\r\n\t.st1DocumentosEletronicosPopup{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    className: "st0DocumentosEletronicosPopup",
    d: "M25,50C11.2,50,0,38.8,0,25S11.2,0,25,0s25,11.2,25,25S38.8,50,25,50z"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    className: "st1DocumentosEletronicosPopup",
    d: "M28.5,25.5c0.1,0.5-0.1,0.9-0.4,1.3l-6.9,7.1v-7.6c1.4-0.5,2.2-2,1.7-3.4c-0.5-1.4-2-2.2-3.4-1.7 c-1.4,0.5-2.2,2-1.7,3.4c0.3,0.8,0.9,1.4,1.7,1.7v7.6l-6.9-7.1c-0.3-0.3-0.5-0.8-0.4-1.3l1.7-9.3h12.9L28.5,25.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    className: "st1DocumentosEletronicosPopup",
    d: "M28.9,12.4c0,0.9-0.7,1.6-1.6,1.6H13.5c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6h13.8 C28.1,10.8,28.8,11.5,28.9,12.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_8",
    className: "st1DocumentosEletronicosPopup",
    d: "M18.4,39.1c2.4-0.4,4.8,0.2,7.2,0.1c1.1,0,2.3-0.3,3.3-0.7c1-0.5,1.9-1.2,2.8-2 c0.9-0.8,2-1.3,3.2-1.4c1.2,0,2.4,0,3.6-0.2c1.9-0.3,3.7-1.6,3.9-3.6c0.1-1.2-1.7-1.2-1.9,0c-0.2,2-3.3,1.9-4.7,1.9 c-1.1,0-2.2,0.1-3.2,0.5c-0.9,0.4-1.8,1-2.5,1.6c-0.7,0.7-1.6,1.2-2.5,1.6c-1,0.3-2.1,0.5-3.2,0.4c-2.2-0.1-4.4-0.5-6.6,0 C16.7,37.5,17.2,39.3,18.4,39.1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeAssineSeusDocumentosEletronicamenteAggerPopup);
export default __webpack_public_path__ + "static/media/icone-assine-seus-documentos-eletronicamente-agger-popup.0ef81d4393cfbd5c9168eb34a81d1fc5.svg";
export { ForwardRef as ReactComponent };